import { Text } from '@core/Components/Text'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'
import { tap } from '@mobi/utils'

export const StewardsCommentsStyled = styled.ul({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx2,
  listStyle: 'none',
  margin: 0,
  padding: 0,
})

export const StewardsCommentTextStyled = tap(
  styled(Text)({
    lineHeight: 'inherit',
    margin: 0,
  }),
  component => {
    component.defaultProps = {
      as: 'p',
      size: 'sm',
    }
  }
)
